'use client';

import { useId } from 'react';
import { Gradient } from '../gradient';

export const Independency = () => {
  const gradientId = useId();

  return (
    <>
      <Gradient gradientId={gradientId} />
      <svg viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_3451_22553)">
          <path
            d="M287.921 133.568L300.463 128L325.001 183.268L312.458 188.837L287.921 133.568Z"
            fill="#2D5B5B"
          />
        </g>
        <g filter="url(#filter1_d_3451_22553)">
          <path
            d="M210.549 172.242L289.523 137.18L310.866 185.253L231.892 220.316L210.549 172.242Z"
            fill={`url(#${gradientId})`}
          />
          <path
            d="M118.853 219.503L214.482 177.046L230.949 214.135L135.32 256.592L118.853 219.503Z"
            fill={`url(#${gradientId})`}
          />
          <path
            d="M75 244.599L121.171 224.101L133.47 251.804L87.2994 272.303L75 244.599Z"
            fill={`url(#${gradientId})`}
          />
        </g>
        <g filter="url(#filter2_d_3451_22553)">
          <path
            d="M205.935 178.361L212.068 175.638L230.383 216.889L224.25 219.612L205.935 178.361Z"
            fill="#2D5B5B"
          />
        </g>
        <g filter="url(#filter3_d_3451_22553)">
          <path
            d="M113.865 224.765L119.998 222.042L134.219 254.073L128.086 256.796L113.865 224.765Z"
            fill="#2D5B5B"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_3451_22553"
            x="281.92"
            y="124"
            width="49.0801"
            height="72.8369"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22553"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22553"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_3451_22553"
            x="69"
            y="133.18"
            width="247.867"
            height="147.123"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22553"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22553"
              result="shape"
            />
          </filter>
          <filter
            id="filter2_d_3451_22553"
            x="199.936"
            y="171.638"
            width="36.4473"
            height="55.9746"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22553"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22553"
              result="shape"
            />
          </filter>
          <filter
            id="filter3_d_3451_22553"
            x="107.865"
            y="218.042"
            width="32.3535"
            height="46.7539"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3451_22553"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3451_22553"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  );
};
